// store.js

import { create } from "zustand";
import {
    addEdge,
    applyNodeChanges,
    applyEdgeChanges,
    MarkerType,
  } from 'reactflow';

export const useStore = create((set, get) => ({
    nodes: [],
    edges: [],
    nodeIDs: {}, // Initialize nodeIDs object to track node counters
    getNodeID: (type) => {
        const newIDs = {...get().nodeIDs};
        if (newIDs[type] === undefined) {
            newIDs[type] = 0;
        }
        newIDs[type] += 1;
        set({nodeIDs: newIDs});
        return `${type}-${newIDs[type]}`;
    },
    addNode: (node) => {
        set({
            nodes: [...get().nodes, node]
        });
    },
    onNodesChange: (changes) => {
      set({
        nodes: applyNodeChanges(changes, get().nodes),
      });
    },
    onEdgesChange: (changes) => {
      set({
        edges: applyEdgeChanges(changes, get().edges),
      });
    },
    onConnect: (connection) => {
      set({
        edges: addEdge({...connection, type: 'smoothstep', animated: true, markerEnd: {type: MarkerType.Arrow, height: '20px', width: '20px'}}, get().edges),
      });
    },
    updateNodeField: (nodeId, fieldName, fieldValue) => {
      set({
        nodes: get().nodes.map((node) => {
          if (node.id === nodeId) {
            node.data = { ...node.data, [fieldName]: fieldValue };
          }

          return node;
        }),
      });
    },

    // Enhanced node data management methods
    getNodeData: (nodeId) => {
      const node = get().nodes.find(n => n.id === nodeId);
      return node?.data || {};
    },

    updateNodeData: (nodeId, updates) => {
      set({
        nodes: get().nodes.map((node) => {
          if (node.id === nodeId) {
            return {
              ...node,
              data: { ...node.data, ...updates }
            };
          }
          return node;
        }),
      });
    },

    // Batch update multiple fields for better performance
    batchUpdateNodeData: (nodeId, updates) => {
      const currentData = get().getNodeData(nodeId);
      const mergedUpdates = { ...currentData, ...updates };
      get().updateNodeData(nodeId, mergedUpdates);
    },

    // Get all nodes of a specific type
    getNodesByType: (nodeType) => {
      return get().nodes.filter(node => node.type === nodeType);
    },

    // Check if node exists
    nodeExists: (nodeId) => {
      return get().nodes.some(node => node.id === nodeId);
    },

    // Get node by ID (full node object)
    getNode: (nodeId) => {
      return get().nodes.find(n => n.id === nodeId);
    },
  }));
